import React from "react";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import EditDetails from "components/pet-details/EditDetails";
import UserAuth from "components/AuthGaurd/UserAuth";

type Props = {};

export default function EditPetDetails({}: Props) {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection
        title={window.location.pathname === "/user/pets/edit-pet-details/add" ? "Add Pet Details" : "Edit Pet Details"}
      >
        <EditDetails />
      </UserHeroSection>
      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
